import { Header, Content } from '@backstage/core-components';
import { EntityPluginDetPortalContent } from '@devxdiscover/plugin-det-portal';

/**
 * Wrapper component for the DET Portal admin plugin.
 * Renders the plugin's main content (admin dashboard).
 */
const DetPortal = () => {
  return (
    <>
      <Header
        title="DET Portal Admin Dashboard"
        subtitle="Manage Artifactory and GHEC requests from DevHub users"
      />
      <Content>
        <EntityPluginDetPortalContent />
      </Content>
    </>
  );
};

export default DetPortal;
